import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  filter: {
    clientIds?: Array<number>
    cameraIds?: Array<number>
    companyIds?: Array<number>
    status?: Array<string>
  }
  start: string
  end: string
  enabled: boolean
}

export default function useDashboardObjectsCount({filter, start, end, enabled}: Props) {
  const query = useQuery({
    refetchOnWindowFocus: false,
    enabled,
    queryKey: [QueryKeyEnum.DASHBOARD_OBJECTS_COUNT, filter, start, end],
    queryFn: async () => (await api.reports.getObjectsCount({filter, start, end})).data.data,
  })

  return query
}
